import Table from '@/view/Adherents/ListeAdherents'
import ListeBilansAdherents from '@/view/Adherents/ListeBilansAdherents'
import ListeHistoriqueBilansAdherents from '@/view/Adherents/ListeHistoriqueBilansAdherents'
import DetailAdherent from '@/view/Adherents/DetailAdherent'
import RendezVousAdherent from '@/view/Adherents/RendezVousAdherent'

const TABLE_BREADCRUMB = {
  code: 'adherents.list.title',
  link: {
    name: 'adherentsCorrespondant',
  },
}

const TABLE_BILANS_BREADCRUMB = {
  code: 'adherents.bilans.title',
  link: {
    name: 'bilansCorrespondant',
  },
}

const TABLE_HISTORIQUE_BILANS_BREADCRUMB = {
  code: 'adherents.bilans.historique.title',
  link: {
    name: 'historiqueBilansCorrespondant',
  },
}

export default [
  {
    path: '/adherentsCorrespondant',
    name: 'adherentsCorrespondant',
    component: Table,
    meta: {
      auth: 'hasRole(ROLE_PARTICIPANT,ROLE_CORRESPONDANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
  },
  {
    path: '/adherents/:id',
    name: 'adherentsCorrespondant/detail',
    component: DetailAdherent,
    meta: {
      auth: 'hasRole(ROLE_PARTICIPANT,ROLE_CORRESPONDANT)',
      breadcrumb: () => [
        TABLE_BREADCRUMB,
        {
          code: 'adherents.overview',
        },
      ],
    },
  },
  {
    path: '/participant/mescoordonnees',
    name: 'participant/mescoordonnees',
    component: DetailAdherent,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_PARTICIPANT)',
    },
    props: true,
  },
  {
    path: '/participant/mesrendezvous',
    name: 'participant/mesrendezvous',
    component: RendezVousAdherent,
    meta: {
      auth: 'hasRole(ROLE_PARTICIPANT)',
    },
  },
  {
    path: '/bilansCorrespondant',
    name: 'bilansCorrespondant',
    component: ListeBilansAdherents,
    meta: {
      auth: 'hasRole(ROLE_CORRESPONDANT)',
      breadcrumb: () => [TABLE_BILANS_BREADCRUMB],
    },
  },
  {
    path: '/historiqueBilansCorrespondant',
    name: 'historiqueBilansCorrespondant',
    component: ListeHistoriqueBilansAdherents,
    meta: {
      auth: 'hasRole(ROLE_CORRESPONDANT)',
      breadcrumb: () => [TABLE_HISTORIQUE_BILANS_BREADCRUMB],
    },
  },
]
